const getters = {
  sidebar: state => state.app.sidebar,
  visitedViews: state => state.tagsView.visitedViews,
  operateData: state => state.dataOperate.operateData,
  role: state => state.role,
  documentWidth: state => state.documentWidth,
  openIndex: state => state.openIndex
}
export default getters
